import { css } from '@emotion/react';
import { areValidDates } from '@frontend/api-invoices';
import { useTranslation } from '@frontend/i18n';
import { classNames } from '@frontend/string';
import { theme } from '@frontend/theme';
import { ButtonBar, DateRangeField, PrimaryButton } from '@frontend/design-system';
import { DateRangeFieldProps, OnDateFilterSelect } from '../../hooks/utils/use-date-filters';

export interface CustomDatePickerProps {
  dateRangeProps: DateRangeFieldProps;
  closePicker: () => void;
  onSelect: OnDateFilterSelect;
  className?: string;
}

export const CustomDatePicker = ({ dateRangeProps, closePicker, onSelect, className }: CustomDatePickerProps) => {
  const { t } = useTranslation('payments');
  const handleSelectCustom = () => {
    onSelect(dateRangeProps.value);
    closePicker();
  };

  const isCustomDisabled = () => {
    const [selfStart, selEnd] = dateRangeProps.value;
    return !areValidDates(selfStart ?? '', selEnd ?? '');
  };

  return (
    <div
      className={classNames('custom-date-range', className)}
      css={css`
        display: flex;
        align-items: center;
        flex-direction: column;
        gap: ${theme.spacing(2)};
        z-index: ${theme.zIndex.popover};
      `}
    >
      <DateRangeField {...dateRangeProps} name='customDateRange' label={t('Custom Date Range')} />
      <ButtonBar
        css={css`
          padding: 0;
        `}
      >
        <PrimaryButton
          disabled={isCustomDisabled()}
          size='small'
          trackingId={`pay-portal-invoicelist-quick-range-btn-custom-range`}
          onClick={handleSelectCustom}
        >
          {t('Apply')}
        </PrimaryButton>
      </ButtonBar>
    </div>
  );
};
